import { useEffect, useState } from 'react'

// The app's phone cutoff. Two ways to qualify as "mobile":
//  - viewport at/below the md breakpoint (768px), matching the SCSS retrofits
//    (portrait phones, small windows), OR
//  - a touch-only device in a short landscape viewport (e.g. an iPhone held
//    sideways is 844px wide — wider than md — but a desktop three-column
//    layout is unusable at 390px of height).
// Kept reactive so rotating or resizing updates the layout live.
export const MOBILE_QUERY =
  '(max-width: 767.98px), (hover: none) and (pointer: coarse) and (max-height: 499.98px)'

const getMatch = (query: string) => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia(query).matches
}

export function useIsMobile(query: string = MOBILE_QUERY): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => getMatch(query))

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }
    const mq = window.matchMedia(query)
    const onChange = () => setIsMobile(mq.matches)
    onChange()
    // Safari <14 only supports the deprecated addListener signature.
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange)
      return () => mq.removeEventListener('change', onChange)
    }
    mq.addListener(onChange)
    return () => mq.removeListener(onChange)
  }, [query])

  return isMobile
}

export default useIsMobile
